import { motion } from "framer-motion";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./carousel";
import { themes } from "../../utils/themes";

function ThemeCarousel() {
  return (
    <section className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Section Header */}
      <motion.div
        className="mb-16 lg:mb-20 mx-auto px-6 lg:px-12"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-4xl">
          <motion.div
            className="h-1 w-24 mb-6"
            style={{ backgroundColor: "#E63946" }}
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          />
          <h2
            className="font-spartan text-[100px] lg:text-[190px] font-bold text-white"
          >
            THEMES
          </h2>
        </div>
      </motion.div>

      {/* Carousel */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="-mt-[124px] lg:-mt-[190px]"
      >
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-screen"
        >
          <CarouselContent className="w-full -ml-px">
            {themes.map((theme) => (
              <CarouselItem
                key={theme.number}
                className="pl-4 md:pl-6 basis-[69%] lg:basis-[30%] flex-shrink-0"
              >
                <div className="relative overflow-hidden h-auto min-h-[420px] rounded-xl flex flex-col justify-between">
                  <div className="absolute inset-0 bg-white z-0" />

                  {/* Accent Line */}
                  <div
                    className="absolute top-0 left-0 w-full h-1"
                    style={{ backgroundColor: theme.accentColor }}
                  />

                  {/* Background Icon Behind Text */}
                  {/* <div className="absolute top-0 right-0 w-2/3 h-2/3 overflow-hidden z-10">
                    <div
                      className="absolute inset-0"
                      style={{
                        WebkitMaskImage: `url(${theme.icon})`,
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskPosition: "top right",
                        WebkitMaskSize: "contain",
                        backgroundColor: theme.accentColor,
                        opacity: 0.1,
                      }}
                    />
                    
                  </div> */}

                  {/* Content */}
                  <div
                    className="relative z-20 p-8 lg:p-10"
                    style={{ minHeight: "380px" }}
                  >
                    {/* Number */}
                    <div className="mb-6 z-20">
                      <span
                        style={{
                          fontFamily: "League Spartan, sans-serif",
                          fontSize: "4rem",
                          fontWeight: "700",
                          color: "#F5F5F5",
                          letterSpacing: "-0.02em",
                        }}
                      >
                        {theme.number}
                      </span>
                    </div>

                    {/* Subtitle */}
                    <div className="mb-4 z-20">
                      <span
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "0.75rem",
                          color: theme.accentColor,
                          letterSpacing: "0.1em",
                          textTransform: "uppercase",
                          fontWeight: "600",
                        }}
                      >
                        {theme.subtitle}
                      </span>
                    </div>

                    {/* Title */}
                    <h3
                      style={{
                        fontFamily: "League Spartan, sans-serif",
                        fontSize: "2rem",
                        fontWeight: "700",
                        color: "#0A0A0A",
                        letterSpacing: "0.02em",
                        textTransform: "uppercase",
                        lineHeight: "1",
                        marginBottom: "1.5rem",
                      }}
                      className="z-20"
                    >
                      {theme.title}
                    </h3>

                    {/* Verse Reference */}
                    <div className="mt-auto pt-6 z-20">
                      <cite
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#666",
                          fontStyle: "italic",
                        }}
                      >
                        {theme.reference}
                      </cite>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-12">
            <CarouselPrevious className="h-9 w-9 relative static translate-y-0 bg-white hover:bg-white border-white text-black hover:bg-white/80 rounded-full pl-1.5" />
            <div className="h-px w-16 bg-white/20" />
            <CarouselNext className="h-9 w-9 relative static translate-y-0 bg-white hover:bg-white border-white text-black hover:bg-white/80 rounded-full pl-1.5" />
          </div>
        </Carousel>
      </motion.div>
    </section>
  );
}

export default ThemeCarousel;
